import { Box, TextField } from '@mui/material'

export interface MatcherInput {
    event: string
    path_prefix: string
    label: string
    item_id: string
}

export const EMPTY_MATCHER: MatcherInput = { event: '', path_prefix: '', label: '', item_id: '' }

export const EVENT_NAME_RE = /^[a-z][a-z0-9_]{0,63}$/

/** Event matcher inputs (event name + optional path prefix / label / item id). */
export function MatcherFields({
    value,
    onChange,
    dense,
}: {
    value: MatcherInput
    onChange: (v: MatcherInput) => void
    dense?: boolean
}) {
    const set = (k: keyof MatcherInput) => (e: React.ChangeEvent<HTMLInputElement>) =>
        onChange({ ...value, [k]: e.target.value })
    const invalid = value.event !== '' && !EVENT_NAME_RE.test(value.event.trim())
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: dense ? '2fr 2fr 1fr 1fr' : '1fr 1fr' },
                gap: 1.5,
                flex: 1,
            }}
        >
            <TextField
                size="small"
                label="Event name"
                required
                value={value.event}
                onChange={set('event')}
                error={invalid}
                helperText={invalid ? 'lowercase letters, digits, _' : undefined}
                placeholder="page_view"
            />
            <TextField
                size="small"
                label="Path starts with"
                value={value.path_prefix}
                onChange={set('path_prefix')}
                placeholder="/checkout"
            />
            <TextField size="small" label="Label" value={value.label} onChange={set('label')} />
            <TextField
                size="small"
                label="Item id"
                value={value.item_id}
                onChange={set('item_id')}
            />
        </Box>
    )
}
